import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withStyles, Typography, Switch } from '@material-ui/core';
import { POI_ACTION_TYPES } from '../../redux-saga/actionTypes';
import theme from '../../theme/theme';
import styles from './styles';

const {
  colors: { checked_toggle, disabled_toggle, toggle_circle },
} = theme;

const AntSwitch = withStyles({
  root: {
    width: '4em',
    height: '2.5em',
    padding: 0,
    right: '1em',
    display: 'flex',
    position: 'absolute',
    marginRight: '.5em',
    borderRadius: '10em',
  },
  switchBase: {
    padding: 0,
    height: '2.000em',
    width: '2.000em',
    marginLeft: '.1em',
    marginTop: '.2em',
    '&$checked': {
      transform: 'translateX(85%)',
      color: toggle_circle,
      left: 0,
      right: '.5em',
      backgroundColor: checked_toggle,
      '& + $track': {
        opacity: 1,
        backgroundColor: checked_toggle,
      },
    },
  },
  thumb: {
    width: '2em',
    height: '2em',
    boxShadow: 'none',
  },
  track: {
    borderRadius: '1.375em',
    opacity: 1,
    backgroundColor: disabled_toggle,
  },
  checked: {},
})(Switch);

const OpenNow = ({ classes, t, filterListEvent, criteriaList }) => {
  const [state, setState] = React.useState(criteriaList.openNow);

  const handleChange = value => {
    setState(previousValue => !previousValue);
    filterListEvent({ criteriaName: 'openNow', value });
  };

  return (
    <React.Fragment>
      <span className={classes.container}>
        <span className={classes.title__container}>
          <Typography className={classes.title}>{t('poi-list.label.open-now')}</Typography>
          <AntSwitch checked={criteriaList.openNow} onChange={() => handleChange(!state)} />
        </span>
      </span>
    </React.Fragment>
  );
};

OpenNow.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  filterListEvent: PropTypes.func.isRequired,
  criteriaList: PropTypes.object.isRequired,
};

const mapStateToProps = ({ poi }) => ({
  criteriaList: poi.filter_criteria_list,
});

const mapDispatchToProps = dispatch => ({
  filterListEvent: payload => dispatch({ type: POI_ACTION_TYPES.FILTER.SET, payload }),
});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withTranslation()(OpenNow)),
);
